export default __webpack_public_path__ + "static/media/27-cn.92a4c050.webp";